import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { syncViewAsFromSearch } from 'state/actions/actions';

/**
 * keeps redux in sync with ?va= on spa navigations. a missing param never
 * resets view-as (in-app links may drop it); leaving is explicit via the header.
 * when the api rejects the target, ?va is stripped so the effect cannot loop
 */
export default function ViewAsAgentSync() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!new URLSearchParams(location.search).has('va')) return undefined;

    let cancelled = false;

    async function run() {
      const { denied } = await dispatch(syncViewAsFromSearch(location.search));
      if (cancelled || !denied) return;

      const params = new URLSearchParams(location.search);
      params.delete('va');
      const qs = params.toString();
      navigate(qs ? `${location.pathname}?${qs}` : location.pathname, {
        replace: true
      });
    }

    run();

    return () => {
      cancelled = true;
    };
  }, [location.search, location.pathname, dispatch, navigate]);

  return null;
}
